import { X } from "lucide-react";
import { memo } from "react";

import {
  DialogClose,
  DialogDescription,
  DialogTitle,
} from "@/components/ui/dialog";

import type { IGlobalSearchHeaderProps } from "./types";

// NOTE: Test ids kept from the SearchChats dialog this palette grew out of.
const GlobalSearchHeaderComponent = ({
  title,
  description,
  closeLabel,
}: IGlobalSearchHeaderProps): JSX.Element => (
  <div
    className="flex items-center justify-center relative px-4 py-5"
    data-testid="search-chats-header"
  >
    <DialogTitle className="text-3xl font-semibold text-center">
      {title}
    </DialogTitle>
    <DialogDescription className="text-center sr-only">
      {description}
    </DialogDescription>
    <DialogClose
      data-testid="search-chats-close"
      className="absolute ltr:right-4 rtl:left-4 top-1/2 -translate-y-1/2 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
    >
      <X className="h-6 w-6" />
      <span className="sr-only">{closeLabel}</span>
    </DialogClose>
  </div>
);

export const GlobalSearchHeader = memo(GlobalSearchHeaderComponent);
